import useAuthStore from '@/store/auth';
import { sendSlackError } from '@/hooks/logger';

export const useGlobalErrorHandler = () => {
  const authStore = useAuthStore();

  const isProd = process.env.NODE_ENV === 'production';

  // 에러 배치 처리를 위한 변수들
  let errorBatch = [];
  let batchTimer = null;
  const BATCH_DELAY = 3000; // 3초

  window.onerror = (message, source, lineno, colno, error) => {
    handleError(error || message);
  };

  window.onunhandledrejection = (event) => {
    handleError(event.reason);
  };

  console.error = (...args) => {
    handleError(args);
  };

  function handleError(error) {
    const sanitizedAuth = sanitizeAuthInfo(authStore.authInfo);

    const errorPayload = {
      message: extractMessage(error),
      stack: extractStack(error),
      url: location.href,
      user: sanitizedAuth,
      timestamp: new Date().toISOString()
    };

    // 에러를 배치에 추가
    addErrorToBatch(errorPayload);
  }

  function addErrorToBatch(errorPayload) {
    errorBatch.push(errorPayload);

    // 타이머가 이미 실행 중이 아닌 경우에만 새로운 타이머 시작
    if (!batchTimer) {
      batchTimer = setTimeout(() => {
        sendBatchErrors();
      }, BATCH_DELAY);
    }
  }

  function sendBatchErrors() {
    if (errorBatch.length === 0) {
      batchTimer = null;

      return;
    }

    const batchPayload = {
      errors: [...errorBatch],
      batchSize: errorBatch.length,
      batchTimestamp: new Date().toISOString()
    };

    // 실서버인 경우에만 Slack으로 전송
    if (isProd) {
      sendSlackError(batchPayload);
    } else {
      console.warn('[GlobalError Batch]', batchPayload);
    }

    // 배치 초기화
    errorBatch = [];
    batchTimer = null;
  }

  function sanitizeAuthInfo(auth) {
    const copy = { ...auth };

    delete copy.accessToken;
    delete copy.refreshToken;

    return copy;
  }

  // 에러 메세지 처리 (console.error로 넘어오는 경우의 수가 많음)
  function extractMessage(error) {
    if (!error) return 'Unknown error';
    if (typeof error === 'string') return error;
    if (Array.isArray(error)) return error.map(extractMessage).join('\n');
    if (error?.message) return error.message;

    return JSON.stringify(error);
  }

  // 스택 정보 추출 (배열인 경우 첫 번째 요소의 스택 사용)
  function extractStack(error) {
    if (!error) return null;
    if (Array.isArray(error)) {
      // axios 에러 등 배열로 들어오는 경우 첫 번째 요소의 스택 사용
      return error[0]?.stack || null;
    }

    return error?.stack || null;
  }
};
